import PartMessage from '../ProductCard/PartMessage'
import {
  ArrowBack,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material'
import ArticleIcon from '@mui/icons-material/Article'
import Divider from '@mui/material/Divider'
import { observer } from 'mobx-react-lite'
import React, {
  ComponentType,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Spinner } from 'react-bootstrap'
import ReactImageMagnifyImport from 'react-image-magnify'
import { useNavigate, useLocation } from 'react-router-dom'
import { EmbeddedCommunicationsManager } from '../../../../../../src/api/embedded/EmbeddedCommunicationsManager'
import { TrackingManager } from '../../../../../../src/config/analytics/tracking'
import {
  I18n,
  Translate,
  useQueryParams,
  useBrandImage,
  MY_PLACE_SELLER,
  generateRandomNumber,
} from 'common'
import PartServiceProvider from '../../../../../../src/services/PartServiceProvider'
import { StoreInstances } from '../../../../../../src/store/StoreInstancesContainer'
import {
  PartDetails,
  PartDetailsParams,
  PartDetailsRequest,
  SearchResultsModel,
  Slide,
} from '../../../../../../src/store/models/SearchModels'
import { NonCachedSearchType, ProductModel } from 'interfaces'
import { useUiStateStore } from '../../../../../../src/store/uiState/UiStateStore'
import { defaultTheme } from '../../../../../../src/theme/index'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { Thumbnail } from '../../../../../../src/ui-components/products/Thumbnail'
import styled from 'styled-components'
import { BrandLinksDrawer } from '../../../../../../src/features/search/Results/BrandLinksDrawer'
import ProductInformation from './ProductInformation'
import ProductSpecifications from '../ProductSpecifications'
import { VehicleFitment } from '../../../../../../src/features/search/Results/components/VehicleFitment'
import { getGoogleAnalyticsCategory } from '../../../../../cart/src/Utils'
import {
  CustomTab,
  CustomTabs,
} from '../../../../../../src/features/vehicleHistory/components/CustomTabs'
import { Box, Grid, ThemeProvider, createTheme } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useSearchStore } from '../../../../../../src/store/search/SearchStore'
import MultiSellerServiceProvider, {
  ISeller,
  IStoreCard,
} from '../../../../../../src/services/MultiSellerServicesProvider'
import { SearchStatus } from 'src/features/search/Results/components/multiSeller/storeCard/Enums'
import { Vehicle } from '../../../../../../src/store/models/Vehicles'
import miscellaneousVehicle from '../../../../../../src/features/search/Results/utils/miscellaneousVehicle'
import {
  buildProductName,
  getSelectedProductQtyAvailable,
} from '../../../../../../src/config/analytics/tracking/utils'
import { IOeInfoDataItem, IOeInfoItem } from './interfaces'
import Carousel from './carousel/carousel'
import Image360View from './Image360View'
import { useImage360 } from './useImage360'
import ViewIn360Button from './ViewIn360Button'

const accordianSummary = createTheme({
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        content: () => ({
          margin: '16px 0px 16px 6px',
        }),
      },
    },
  },
})

const ProductDetails = observer((): ReactElement => {
  const navigate = useNavigate()
  const location = useLocation()
  const [carouselSlides, setCarouselSlides] = useState<Slide[]>([])
  const query = useQueryParams()

  const {
    currentVehicle,
    partDetailsLoading,
    partDetailsError,
    setPartDetailsError,
    lastNonCachedSearch,
    setpartDetailsLoading,
  } = useSearchStore()

  const [value, setValue] = useState(0)

  const from = (location.state as { from?: string })?.from

  const backLabelKey =
    from === 'cart'
      ? 'backToCart'
      : from === 'orderHistory' ||
          from === 'orderReturn' ||
          from === 'orderConfirmation'
        ? 'backToOrderDetails'
        : 'backToSearchResults'

  const [selectedProduct, setSelectedProduct] = useState<
    ProductModel | undefined
  >(location.state as ProductModel)

  const uiStore = useUiStateStore()

  const [partDetails, setPartDetails] = useState<PartDetails>({})

  const [searchResultsData, setSearchResultsData] =
    useState<SearchResultsModel>({})

  const [sellerDetails, setSellerDetails] = useState<ISeller>()

  const {
    displayErrorNotification,
    showBrandLinksDrawer,
    setShowBrandLinksDrawer,
    isMultisellerUser,
    isDisplayMultiSellerLogos,
  } = uiStore

  const handleBackButton = () => {
    navigate(-1)
  }
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const ReactImageMagnify = ReactImageMagnifyImport as unknown as ComponentType<
    Record<string, unknown>
  >

  useEffect(() => {
    const partNumber = query.get('partNumber')
    const lineCode = query.get('lineCode')
    const coverageKey = query.get('coverageKey')

    if (partNumber && lineCode) {
      // Handle if user already have part selected.
      if (
        selectedProduct &&
        selectedProduct.partNumber === partNumber &&
        selectedProduct.lineCode === lineCode
      ) {
        return
      }
      PartServiceProvider.byPartsApi(
        {
          start: 0,
          limit: 10,
          clientUTCOffset: StoreInstances.userStore.utcOffset,
          parts: [{ partNumber, lineCode, qty: 1, description: '' }],
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as unknown as any,
        false,
        coverageKey || '',
        true
      ).then((data) => {
        if (data.parts && data.parts.length > 0 && data.parts[0]) {
          setSearchResultsData(data)
          setSelectedProduct(data.parts[0])
        }
      })
    }
  }, [query, selectedProduct])

  useEffect(() => {
    const coverageKey = query.get('coverageKey')
    if (selectedProduct && selectedProduct.partNumber) {
      const reqBody: PartDetailsRequest = {
        vehicle: currentVehicle,
        manufacturerName: selectedProduct.manufacturerName || '',
        clientUTCOffset: StoreInstances.userStore.utcOffset,
        group: selectedProduct.group || { id: '', value: '' },
        partTypeIds: selectedProduct.terminologyId,
      }
      const queryParams: PartDetailsParams = {
        allianceProductId: selectedProduct.allianceProductId,
        lineCode: selectedProduct.lineCode,
        partNumber: selectedProduct.partNumber,
        orderNumber: selectedProduct.orderNumber?.toString() || '',
        manufacturerID: selectedProduct.manufacturerId?.toString() || '',
      }
      setpartDetailsLoading(true)
      PartServiceProvider.getPartDetails(
        reqBody,
        queryParams,
        coverageKey || ''
      )
        .then((data) => {
          setPartDetails(data)
          if (data.partMessage && !selectedProduct.partMessage) {
            setSelectedProduct((prev) => ({
              ...prev,
              partMessage: data.partMessage,
            }))
          }
          setpartDetailsLoading(false)
          const category = getGoogleAnalyticsCategory(
            selectedProduct?.allianceterminologyId ?? '',
            selectedProduct?.description ?? ''
          )
          TrackingManager.trackEvent('view_item', {
            items: [
              {
                item_id: `${selectedProduct.lineCode} ${selectedProduct.partNumber}`,
                item_name: buildProductName(selectedProduct),
                item_brand:
                  selectedProduct.brandName ?? selectedProduct.manufacturerName,
                item_category: category,
                price: selectedProduct.location?.[0]?.cost, // Asumming the first in the array is the selected one
                quantity: getSelectedProductQtyAvailable(selectedProduct),
              },
            ],
          })
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((e: any) => {
          setpartDetailsLoading(false)
          setPartDetailsError(`${e.message} - ${e.response.data.message}`)
        })
    }

    return () => {
      setPartDetails({})
    }
  }, [
    currentVehicle,
    query,
    selectedProduct,
    setPartDetailsError,
    setpartDetailsLoading,
  ])

  useEffect(() => TrackingManager.pageView('/productDetails'), [])

  const isImageUrl = (url: string): boolean => {
    return (
      ['.jpg', '.png', '.jpeg'].findIndex((extension) =>
        url.toLowerCase().endsWith(extension)
      ) !== -1
    )
  }

  useEffect(() => {
    const abc = (partDetails.digitalAssets || [])
      .filter(
        (item) =>
          item.assetType.startsWith('P') &&
          item.url !== '' &&
          isImageUrl(item.url)
      )
      .map((slideObj) => {
        return {
          id: generateRandomNumber(10, 99),
          alt: '',
          src: slideObj.url,
        }
      })
    setCarouselSlides(abc)
  }, [partDetails])

  const [mainImageurl, setMainImageurl] = useState<string | null>(null)
  const [show360Image, setShow360Image] = useState(false)
  const [image360Url, setImage360Url] = useState('')
  const { images: images360, loading: loading360Viewer } = useImage360({
    url: image360Url,
  })
  const [brandImgUrl] = useBrandImage(selectedProduct)

  useEffect(() => {
    let initialImageUrl = partDetails.partImageUrl

    if (!initialImageUrl && carouselSlides && carouselSlides[0]) {
      initialImageUrl = carouselSlides[0].src
    }
    setMainImageurl(initialImageUrl || null)
  }, [partDetails, setMainImageurl, carouselSlides])

  useEffect(() => {
    if (partDetailsError !== '') {
      displayErrorNotification(partDetailsError)
    }

    return () => {
      setPartDetailsError('')
    }
  }, [partDetailsError, setPartDetailsError, displayErrorNotification])

  const handleOnHover = (slide: Slide) => {
    setMainImageurl(slide.src)
    setShow360Image(slide.alt === '360-image')
  }

  const showNonASTLinks =
    !EmbeddedCommunicationsManager.isAstPunchOut &&
    lastNonCachedSearch !== NonCachedSearchType.searchByAstNavigation

  function groupByDescription(data: IOeInfoDataItem[]) {
    if (!Array.isArray(data) || data.length === 0 || data === undefined) {
      return []
    }

    const descriptionMap = data.reduce((acc, item) => {
      const { partNumber, description } = item
      if (!acc[description]) {
        acc[description] = {
          description,
          partNumber: [],
        }
      }
      acc[description].partNumber.push(partNumber)
      return acc
    }, {})

    return Object.values(descriptionMap)
  }

  const vehicle: Vehicle = useMemo(() => {
    try {
      const vehicleParam = query.get('vehicle')

      if (vehicleParam) {
        const decodedVehicle = decodeURIComponent(vehicleParam)
        const parsedVehicle: Vehicle = JSON.parse(decodedVehicle)

        if (parsedVehicle?.engine?.id) {
          return parsedVehicle
        }
      }

      if (currentVehicle?.engine?.id) {
        return currentVehicle
      }

      return miscellaneousVehicle
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      return miscellaneousVehicle
    }
  }, [currentVehicle, query])

  useEffect(() => {
    const coverageKey = query.get('coverageKey') || ''
    const storeName = query.get('storeName')
    if (!coverageKey && !storeName) {
      setSellerDetails({
        ...MY_PLACE_SELLER,
      })
      return
    }
    if (!uiStore?.isMultisellerUser()) {
      setSellerDetails({
        ...MY_PLACE_SELLER,
      })
      return
    }
    MultiSellerServiceProvider.getActiveSellers()
      .then((externalSellers) => {
        const myPlaceSeller = MY_PLACE_SELLER
        const myPlaceStoreCard = { ...myPlaceSeller, isMyPlaceStore: true }
        const sellers = [myPlaceStoreCard, ...externalSellers]
        const toStoreCard = (s) => ({
          ...s,
          selected: s.isMyPlaceStore,
          searchStatus: SearchStatus.LOADING,
        })
        const selectedSeller: IStoreCard = sellers
          .map(toStoreCard)
          .find((seller) => seller.coverageKey === coverageKey)

        setSellerDetails(selectedSeller)
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err)
      })
  }, [query, uiStore])

  useEffect(() => {
    if (!partDetails) return

    const zipAsset = partDetails.digitalAssets?.find(
      ({ fileType, assetType }) =>
        fileType?.toLowerCase() === 'zip' && assetType === '360'
    )

    if (zipAsset?.url) setImage360Url(zipAsset.url)
  }, [partDetails])

  const isFirstSlideSelected = useMemo(() => {
    return mainImageurl === carouselSlides?.[0]?.src
  }, [carouselSlides, mainImageurl])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {selectedProduct && partDetails ? (
        <Wrapper>
          <BackButtonWrapper onClick={handleBackButton}>
            <BackButtonIcon />
            <I18n name={backLabelKey} />
          </BackButtonWrapper>
          <MobileTopMenu>
            <MobileViewButton onClick={handleBackButton}>
              <MobileBackButtonIcon />
              <I18n name={backLabelKey} />
            </MobileViewButton>
            <ActionWrapper onClick={() => uiStore.updateYourCost()}>
              {uiStore.showYourCost() ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              )}
              <ActionText>
                <I18n name="yourCost" />
              </ActionText>
            </ActionWrapper>
            {brandImgUrl && (
              <MobileBrandImage>
                <Thumbnail
                  urlOrBase64={brandImgUrl}
                  width={100}
                  height={100}
                  alt="brand"
                />
              </MobileBrandImage>
            )}
          </MobileTopMenu>
          {sellerDetails && isMultisellerUser() && (
            <MultiSellerDetials>
              {(isDisplayMultiSellerLogos() || !sellerDetails.coverageKey) && (
                <Thumbnail
                  urlOrBase64={sellerDetails.logoUrl}
                  width={142}
                  placeholder
                />
              )}
              <MultiSellerInfo>
                <I18n
                  name="soldBy"
                  textReplacement={[sellerDetails.sellerName]}
                />
              </MultiSellerInfo>
            </MultiSellerDetials>
          )}

          <ProductInformationDetials>
            <ProductName>{selectedProduct?.description}</ProductName>
            <MobilePriceInformation>
              <NoWrap>
                <span style={{ whiteSpace: 'nowrap' }}>
                  <I18n name="partNum" />
                  :&nbsp;
                </span>
                {selectedProduct?.partNumber}
              </NoWrap>
              <Divider
                orientation="vertical"
                variant="middle"
                style={{ margin: '5px', height: '15px' }}
              />
              <NoWrap>
                <I18n name="lineCode" />: {selectedProduct?.lineCode}
              </NoWrap>
            </MobilePriceInformation>
            <PartMessage message={selectedProduct?.partMessage?.[0]} />
          </ProductInformationDetials>

          <Container>
            <ImageContainerMobile>
              <CarouselSlides>
                {carouselSlides !== undefined && carouselSlides.length > 0 ? (
                  <Carousel
                    slides={carouselSlides}
                    onHover={handleOnHover}
                    show360Slide={Boolean(image360Url)}
                  />
                ) : null}
              </CarouselSlides>
              {show360Image ? (
                <Image360Container>
                  <Image360View images={images360} loading={loading360Viewer} />
                </Image360Container>
              ) : (
                <ImageOnlyContainer>
                  <MainImageContainer>
                    {partDetailsLoading ? (
                      <Spinner animation="border" />
                    ) : (
                      <ImageContainer>
                        {mainImageurl === null ? (
                          <Thumbnail
                            urlOrBase64={mainImageurl}
                            width={255}
                            height={255}
                            placeholder
                          />
                        ) : (
                          <ImageWrapper width={255} height={255}>
                            <ReactImageMagnify
                              imageClassName="carrousel-main-image"
                              {...{
                                smallImage: {
                                  alt: mainImageurl,
                                  isFluidWidth: true,
                                  src: mainImageurl,
                                },
                                largeImage: {
                                  src: mainImageurl,
                                  width: 800,
                                  height: 1000,
                                },
                                enlargedImageContainerDimensions: {
                                  width: 754,
                                  height: 553,
                                },
                                enlargedImageStyle: {
                                  objectFit: 'contain',
                                },
                                enlargedImageContainerStyle: {
                                  position: 'absolute',
                                  top: 0,
                                  background: '#FFF',
                                  border: '2px solid #CCC',
                                },
                                enlargedImagePortalId: 'zoom-box',
                              }}
                            />
                          </ImageWrapper>
                        )}
                      </ImageContainer>
                    )}
                  </MainImageContainer>
                  {Boolean(image360Url) && isFirstSlideSelected && (
                    <ViewIn360Button onClick={handleOnHover} />
                  )}
                  <NoticeMessage>
                    {Translate('rollOverImageToZoom')}
                  </NoticeMessage>
                </ImageOnlyContainer>
              )}
            </ImageContainerMobile>
            <ProductInfoDesktop>
              <ProductInformation
                partDetails={partDetails}
                selectedProduct={selectedProduct}
                searchResultsData={searchResultsData}
                sellerDetails={sellerDetails}
                vehicle={vehicle}
              />
            </ProductInfoDesktop>
          </Container>
          <Divider />
          <ProductSpecifications
            partDetails={partDetails}
            selectedProduct={selectedProduct}
          />
          <ManufacturerDetailsContainer>
            <Title>{Translate('manufacturerDetails')}: &nbsp;</Title>
            {brandImgUrl ? (
              <Link
                onClick={() => {
                  setShowBrandLinksDrawer(true, selectedProduct)
                }}
              >
                {selectedProduct?.brandName ??
                  selectedProduct?.manufacturerName}
              </Link>
            ) : (
              <ManufactureRightSideText>
                {selectedProduct?.brandName ??
                  selectedProduct?.manufacturerName}
              </ManufactureRightSideText>
            )}
          </ManufacturerDetailsContainer>
          <BoxContainer
            sx={{
              bgcolor: defaultTheme.colors.componentsBackground,
              borderBottom: `1px solid ${defaultTheme.colors.greyMedium}`,
            }}
          >
            <CustomTabs
              value={value}
              onChange={handleChange}
              aria-label="ant example"
              sx={{
                borderBottom: '1px solid transparent !important',
                '& .MuiTabs-flexContainer': {
                  gap: '32px',
                },
                [`@media (max-width: ${breakpoints.mobileLarge}px)`]: {
                  borderBottom: '1px solid black !important',
                },
              }}
              variant="scrollable"
            >
              <CustomTab
                label={Translate('specifications')}
                value={0}
                sx={{
                  paddingX: '0px !important',
                  paddingTop: '8px !important',
                  paddingBottom: '14px !important',
                }}
              />
              {showNonASTLinks &&
                sellerDetails &&
                sellerDetails.coverageKey === '' && (
                  <CustomTab
                    label={Translate('vehicleFitment')}
                    value={1}
                    sx={{
                      paddingX: '0px !important',
                      paddingTop: '8px !important',
                      paddingBottom: '14px !important',
                    }}
                  />
                )}
              <CustomTab
                label={Translate('oeCrossReference')}
                value={2}
                sx={{
                  paddingX: '0px !important',
                  paddingTop: '8px !important',
                  paddingBottom: '14px !important',
                }}
              />
              <CustomTab
                label={Translate('additionalResources')}
                value={3}
                sx={{
                  paddingX: '0px !important',
                  paddingTop: '8px !important',
                  paddingBottom: '14px !important',
                }}
              />
            </CustomTabs>
          </BoxContainer>

          {value === 0 && (
            <>
              {partDetailsLoading && <Spinner animation="border" />}
              {partDetails?.attributes === null ||
              partDetails?.attributes?.length === 0 ? (
                <Paragrah>{Translate('noData')}</Paragrah>
              ) : (
                <Grid
                  container
                  columnSpacing={3}
                  rowSpacing={0.5}
                  style={{ marginTop: '20px' }}
                >
                  {partDetails?.attributes?.map((attribute) => (
                    <SpecificationDivItem
                      columnGap={0.5}
                      item
                      key={attribute.key}
                      xs={12}
                      sm={6}
                    >
                      <SpecificationDivKey xs={6}>
                        {attribute.key}
                      </SpecificationDivKey>
                      <SpecificationDivValue xs={6}>
                        {attribute.value}
                      </SpecificationDivValue>
                    </SpecificationDivItem>
                  ))}
                </Grid>
              )}
            </>
          )}
          {value === 1 && <VehicleFitment selectedProduct={selectedProduct} />}
          {value === 2 && (
            <>
              {partDetailsLoading && <Spinner animation="border" />}
              {/* <TextField
                id="input-with-icon-textfield"
                placeholder="Search by manufacturer, part number"
                InputProps={{
                  sx: { color: 'red' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchRounded />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  sx: {
                    padding: '12px 87px 12px 0px',
                    color: '#6B6B6B !important',
                  },
                }}
                sx={{ width: '30%', mt: 3 }}
                variant="outlined"
              /> */}
              <OeCrossReferenceHeader>
                <HeaderRow>
                  <OeColHeader>
                    <I18n name="manufacturers" />
                  </OeColHeader>
                </HeaderRow>
              </OeCrossReferenceHeader>
              {(groupByDescription(partDetails?.oeInfo) as IOeInfoItem[]) ===
                null ||
              (groupByDescription(partDetails?.oeInfo) as IOeInfoItem[])
                ?.length === 0 ? (
                <Paragrah>{Translate('noData')}</Paragrah>
              ) : null}
              {(groupByDescription(partDetails?.oeInfo) as IOeInfoItem[])?.map(
                (attribute: IOeInfoItem, index: number) => (
                  <div key={index}>
                    <Accordion>
                      <ThemeProvider theme={accordianSummary}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              style={{
                                marginRight: 'auto',
                                color: '#000',
                                width: 20,
                                height: 20,
                                marginLeft: '0.5rem',
                              }}
                            />
                          }
                          aria-controls={`panel${index}bh-content`}
                          id={`panel${index}bh-header`}
                          sx={{
                            flexDirection: 'row-reverse', // Align content to the left
                            backgroundColor: '#FAFAFA',
                            borderBottom: '1px solid #ADADAA',
                            fontWeight: '700',
                            fontFamily: 'Roboto',
                            padding: 0,
                          }}
                        >
                          {attribute?.description}
                        </AccordionSummary>
                      </ThemeProvider>
                      <AccordionDetails
                        sx={{
                          backgroundColor: '#EBEBEB',
                          fontWeight: '400',
                          fontFamily: 'Roboto',
                          padding: 0,
                        }}
                      >
                        <Grid
                          container
                          py={1}
                          rowSpacing={1}
                          columnSpacing={4.5}
                          ml={0}
                          width="100%"
                        >
                          {attribute?.partNumber.map((val) => (
                            <Grid item xs={6} md={3} key={val}>
                              {val}
                            </Grid>
                          ))}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )
              )}
            </>
          )}

          {value === 3 && (
            <AdditionalResourcesContainer
              container
              columnSpacing={4}
              rowSpacing={0.5}
            >
              {' '}
              {partDetails.digitalAssets === null ||
              partDetails.digitalAssets?.length === 0 ? (
                <Paragrah style={{ marginLeft: '35rem' }}>
                  {Translate('noData')}
                </Paragrah>
              ) : null}
              {partDetails.digitalAssets?.map((asset) => {
                return (
                  asset.assetType?.startsWith('B') && (
                    <ResourcesWrapper item xs={12} sm={6} md={3}>
                      <ResourcesIcon
                        sx={{
                          width: 16,
                          height: 16,
                          marginRight: '4px !important',
                          marginTop: '2px',
                          marginBottom: '2px',
                        }}
                      />
                      {asset.url ? (
                        <Link
                          target="blank"
                          href={asset.url}
                          style={{ textDecoration: 'none', fontSize: '16px' }}
                        >
                          {asset.fileName}
                        </Link>
                      ) : (
                        <div>
                          {asset.fileName} [
                          {Translate('temporarilyUnavailable')}]
                        </div>
                      )}
                    </ResourcesWrapper>
                  )
                )
              })}
            </AdditionalResourcesContainer>
          )}
          {showBrandLinksDrawer && <BrandLinksDrawer />}
        </Wrapper>
      ) : (
        <Spinner animation="border" style={{ margin: '50px' }} />
      )}
    </div>
  )
})

export default ProductDetails

interface ImgSize {
  width: number
  height: number
}
interface HeaderRowProps {
  width?: string
}

const MobileBrandImage = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    cursor: pointer;
    margin-left: 20px;
  }
`
const ActionWrapper = styled.div`
  display:none;
@media screen and (max-width: ${breakpoints.mobileLarge}px) {
  display:flex;
  cursor: pointer;
  margin-left: 20px;
  display: flex;
  height: 100%;
  align-items: center;
  border-left: 1px solid ${defaultTheme.colors.border};
  margin-left:20px
  cursor: pointer;
}

`
const ActionText = styled.span`
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  padding: 5px;
  color: #000000;
  user-select: none;
`

const MobileViewButton = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: flexPro;
    flex-direction: row;
    color: ${defaultTheme.colors.blueLight};
    margin: 20px;
    gap: 14px;
    flex-direction: row;
  }
`
const MobileTopMenu = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    flex-direction: column;
  }
`
const CarouselSlides = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    flex-direction: row;
  }
`

const ImageContainerMobile = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    flex-direction: column-reverse;
  }
`
const ProductInformationDetials = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: flex;
    flex-direction: column;
    text-align: start;
    margin: 20px;
  }
`
const MultiSellerDetials = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 10px 20px 0px;
  align-items: center;
`
const MultiSellerInfo = styled.span`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-left: 15px;
  justify-content: center;
`
const ProductInfoDesktop = styled.div`
  display: flex;
`
const ImageOnlyContainer = styled.div`
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    margin: 20px;
  }
`

const ProductName = styled.div`
  font-family: Oswald, serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    text-align: left;
  }
`
const MobilePriceInformation = styled.div`
  display: flex;
  flex-direction: row;
`

const ImageWrapper = styled.div<ImgSize>`
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

const NoWrap = styled.span`
  white-space: nowrap;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 35px 36px 0px 57px;
  font-family: Roboto, serif;
  background: #ffffff;
  margin: 16px 20px 13px 20px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    padding: 0px;
    width: 100%;
  }
`
const BackButtonWrapper = styled.div`
  width: fit-content;
  color: ${defaultTheme.colors.blueLight};
  cursor: pointer;
  font-family: Roboto, serif;
  font-weight: normal;
  @media screen and (max-width: ${breakpoints.tablet}px) {
  }
  @media print {
    display: none;
  }
`
const BackButtonIcon = styled(ArrowBack)`
  padding: 3px;
`
const MobileBackButtonIcon = styled(ArrowBack)``

const Container = styled.div`
  display: flex;
  position: relative;
  margin-top: 10px;
  @media (max-width: 1300px) {
    flex-direction: column;
  }
`
const MainImageContainer = styled.div`
  width: 430px;
  height: 503px;
  border: 2px solid #d3d2cf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 25px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 100%;
  }
`

const NoticeMessage = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
  margin-top: 11px;
`
const ImageContainer = styled.div`
  width: 253px;
  height: 255px;
  align-items: center;
  justify-content: center;
`
const AdditionalResourcesContainer = styled(Grid)`
  margin-top: 24px;
  text-align: left;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    padding: 25px;
    margin-top: 10px;
  }
`
const ManufacturerDetailsContainer = styled(AdditionalResourcesContainer)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 48px;
  text-align: left;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    padding: 25px;
    margin-top: 10px;
  }
`

const Title = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
`

const Link = styled.a`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  /* identical to box height, or 133% */

  text-decoration-line: underline;

  /* Blue */
  color: ${defaultTheme.colors.blueLight};

  mix-blend-mode: normal;
  cursor: pointer;
`
const ResourcesWrapper = styled(Grid)`
  display: flex;
  padding: 8px 8px 0px 36px;
`

const ResourcesIcon = styled(ArticleIcon)`
  color: ${defaultTheme.colors.blueLight};
  margin-right: 6.5px;
`
const BoxContainer = styled(Box)`
  display: flex;
  margin-top: 28px;
`
const Paragrah = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: justify;
  padding: 0px;
  margin-top: 16px;
`

const SpecificationDivItem = styled(Grid)`
  display: flex;
  justify-content: center;
`
const SpecificationDivKey = styled(Grid)`
  background: #ebebeb;
  padding: 0.5rem 1rem;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
  font-size: 18px !important;
`
const SpecificationDivValue = styled(Grid)`
  background: #fafafa;
  padding: 0.5rem 1rem;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  font-size: '16px !important';
`

const OeCrossReferenceHeader = styled.div`
  margin-top: 8px;
  min-width: 450px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    overflow-x: scroll;
  }
`
const ColHeader = styled.div<HeaderRowProps>`
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: bold;
  align-items: center;
  font-size: 18px;
  line-height: 27px;
  width: ${(p) => p.width};
  color: #ffffff;
  mix-blend-mode: normal;
  padding-right: 24px;
  padding-left: 24px;
`
const HeaderRow = styled.div`
  background-color: #000;
  color: #fff;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
  text-align: left;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    height: 60px;
  }
`
const OeColHeader = styled(ColHeader)`
  width: 40%;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 50%;
  }
`
const ManufactureRightSideText = styled.div`
  color: ${defaultTheme.colors.blueLight};
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  font-size: '16px !important';
  text-decoration: underline;
`

const Image360Container = styled.div`
  width: 430px;
  height: 503px;
  margin: 10px;

  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    align-self: center;
    width: 98%;
    margin: 0;
  }
`
